/* eslint-disable complexity */
import { ChatType } from "../../components/popUp/popUpChatHistory/ChatDialog";
import { ChatConversation, ChatMessage } from "../responsePayload/ChatResponse";
import { PageResponse } from "../responsePayload/PageResponse";

export const mapChatHistoryResponse = (
  json: any
): PageResponse<ChatConversation> => ({
  count: json?.count ?? 0,
  totalPages: json?.total_pages ?? 0,
  currentPage: json?.current_page ?? 1,
  next: json?.next ?? undefined,
  previous: json?.previous ?? undefined,
  results: Array.isArray(json?.results)
    ? json.results.map(mapConversation)
    : [],
});

const mapConversation = (c: any): ChatConversation => ({
  memberId: String(c?.member_id ?? ""),
  conversationId: String(c?.conversation_id ?? ""),
  createdAt: new Date(c?.created ?? 0),
  updatedAt: new Date(c?.last_updated ?? 0),
  endReason: c?.end_reason ?? 0,
  messages: Array.isArray(c?.messages)
    ? c.messages
        .map(mapMessage)
        .sort((a: any, b: any) => +a.createdAt - +b.createdAt)
    : [],
});

// Map whatever the API sends → your ChatType
const mapApiRoleToChatType = (role: unknown): ChatType => {
  switch (String(role ?? "").toLowerCase()) {
    case "user":
      return ChatType.User;

    // treat any human operator labels as CustomerSupport
    case "admin":
    case "agent":
    case "support":
    case "customer_support":
      return ChatType.CustomerSupport;

    // treat any AI labels as JokerBot
    case "ai":
    case "assistant":
    case "bot":
    case "robot":
      return ChatType.JokerBot;

    default:
      // safe fallback
      return ChatType.JokerBot;
  }
};

const mapMessage = (m: any): ChatMessage => ({
  id: String(m?.message_id ?? ""),
  role: mapApiRoleToChatType(m?.role),

  text: String(m?.message ?? ""),
  images: Array.isArray(m?.image_urls) ? m.image_urls.map(String) : [],
  inReplyTo: m?.in_reply_to ?? undefined,
  adminAction: m?.admin_action ?? undefined,
  aiCheckpoint: Boolean(m?.ai_checkpoint),
  createdAt: m?.created_datetime ?? "",
});
